export default __webpack_public_path__ + "static/media/touchThree.0d24549e.svg";